var removeDataAnalyticsAttrOnBodyTag = function () {
    if (!document.body.getAttribute('data-analytics-page-type'))
        return;
    document.body.removeAttribute('data-analytics-page-type');
};

export { removeDataAnalyticsAttrOnBodyTag };
//# sourceMappingURL=removeDataAnalyticsAttrOnBodyTag.esm.js.map
